import React from "react";
import { Button, Card, Typography, Row, Flex, Collapse } from "antd";

import Tarot from "./tarot";
import { sample } from "lodash";

export default function List({ onChange, tarots, value }) {
  const arkans = tarots.filter((t) => t.suit === "arkan");
  const swords = tarots.filter((t) => t.suit === "sword");
  const cups = tarots.filter((t) => t.suit === "cup");
  const wands = tarots.filter((t) => t.suit === "wand");
  const pentacles = tarots.filter((t) => t.suit === "pentacle");
  const others = tarots.filter((t) => t.suit == null);

  const selectRandom = () => {
    const randomTaro = sample(tarots);
    onChange(randomTaro.id);
  };

  const clear = () => onChange(null);

  const renderTarotsCards = (collection) => (
    <Flex wrap gap={10}>
      {collection.map((t) => (
        <Tarot
          key={`tarot-field-${t.id}`}
          onSelect={onChange}
          active={t.id === value}
          {...t}
        />
      ))}
    </Flex>
  );

  const selectedTarot = tarots.find((t) => t.id === value);

  return (
    <>
      <Card type="inner" style={{ position: "sticky", top: 0, zIndex: 2 }}>
        <Row>
          <Typography.Text style={{ marginRight: 10 }} strong>
            {selectedTarot && selectedTarot.title}
          </Typography.Text>
          <Button.Group>
            <Button onClick={selectRandom}>Random</Button>
            {value && <Button onClick={clear}>Clear</Button>}
          </Button.Group>
        </Row>
      </Card>
      <Collapse accordion defaultActiveKey="arkans">
        <Collapse.Panel header="Arkans" key="arkans">
          {renderTarotsCards(arkans)}
        </Collapse.Panel>
        <Collapse.Panel header="Swords" key="swords">
          {renderTarotsCards(swords)}
        </Collapse.Panel>
        <Collapse.Panel header="Cups" key="cups">
          {renderTarotsCards(cups)}
        </Collapse.Panel>
        <Collapse.Panel header="Winds" key="winds">
          {renderTarotsCards(wands)}
        </Collapse.Panel>
        <Collapse.Panel header="Pentacles" key="pentacles">
          {renderTarotsCards(pentacles)}
        </Collapse.Panel>
        {!!others.length && (
          <Collapse.Panel header="Other" key="other">
            {renderTarotsCards(others)}
          </Collapse.Panel>
        )}
      </Collapse>
    </>
  );
}
